'use client'
export default function Loading() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-[#1a1a1a]">
      <div className="w-12 h-12 border-pro rounded-full animate-spin"></div>
    </div>
  );
}
